<template>
  <div>
    <div class="full-width">
      <project-details v-if="selectedProject" :project="selectedProject"/>
    </div>

    <q-tabs color="white" underline-color="primary" class="project__tabs no-border">
      <q-tab name="time-tracking" slot="title" default :label="$t('time_tracking')" color="black"/>
      <q-tab name="invoices" slot="title" :label="$tc('invoice', 2)" color="black"/>
      <q-tab name="quotes" slot="title" :label="$tc('quote', 2)" color="black"/>
      <q-tab name="expenses" slot="title" :label="$tc('expense', 2)" color="black"/>

      <time-entries :project="selectedProject"/>
      <invoices :project="selectedProject"/>
      <quotes :project="selectedProject"/>
      <expenses :project="selectedProject"/>
    </q-tabs>
  </div>
</template>

<script>
  import Expenses from 'components/TimeTracking/Projects/Tabs/Expenses.vue'
  import Invoices from 'components/TimeTracking/Projects/Tabs/Invoices.vue'
  import ProjectDetails from 'components/TimeTracking/Projects/ProjectDetails.vue'
  import Quotes from 'components/TimeTracking/Projects/Tabs/Quotes.vue'
  import TimeEntries from 'components/TimeTracking/Projects/Tabs/TimeEntries.vue'
  import { mapGetters } from 'vuex'
  import store from 'src/store'

  export default {
    computed: mapGetters(['selectedProject']),

    beforeRouteEnter (to, from, next) {
      const project = store.dispatch('fetchSelectedProject', to.params.project)

      const timeEntries = store.dispatch('listTimeEntries', {
        pagination: {
          filterBy: [
            ['user_id', '=', store.getters.user.id],
            ['project_id', '=', to.params.project],
            ['running', '=', false]
          ]
        }
      })

      Promise.all([project, timeEntries])
        .then(next)
    },

    beforeRouteUpdate (to, from, next) {
      const project = store.dispatch('fetchSelectedProject', to.params.project)

      const timeEntries = store.dispatch('listTimeEntries', {
        pagination: {
          filterBy: [
            ['user_id', '=', store.getters.user.id],
            ['project_id', '=', to.params.project],
            ['running', '=', false]
          ]
        }
      })

      Promise.all([project, timeEntries])
        .then(next)
    },

    components: {
      Invoices,
      ProjectDetails,
      TimeEntries,
      Quotes,
      Expenses
    }
  }
</script>

<style lang="stylus">
  @import '~variables'

  .project__tabs
    @media (max-width $breakpoint-sm-max)
      .q-tabs-head
        padding 0 .5rem
    @media (min-width $breakpoint-md-min) and (max-width $breakpoint-md-max)
      .q-tabs-head
        padding 0 2rem
    @media (min-width $breakpoint-lg-min) and (max-width $breakpoint-lg-max)
      .q-tabs-head
        padding 0 3rem
    @media (min-width $breakpoint-xl-min)
      .q-tabs-head
        padding 0 4rem
</style>
